<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Delete selected approval limit?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected approval limit.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="deleteLimitById" :loading="getLoading" :disable="getLoading">delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialogForm" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">{{dialogTitle}} Approval Limit</v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field type="number" v-model.number="activeLimit.total_value_from" label="Min. Limit" :error-messages="errors.collect('min limit')"
                      v-validate="'required|numeric'" data-vv-name="min limit" required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field type="number" v-model.number="activeLimit.total_value_to" label="Max. Limit" :error-messages="errors.collect('max limit')"
                      v-validate="'required|numeric'" data-vv-name="max limit" required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox label="Unlimited" v-model="activeLimit.is_unlimited" light true-value="1" false-value="0"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialogForm = false">cancel</v-btn>
              <v-btn color="accent" flat @click="dialogFormSubmit" :loading="getLoading" :disable="getLoading">
                save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Approval limits profile</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="formSubmit">
            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="profile.description" label="Profile description" :error-messages="errors.collect('description')" v-validate="'required'"
                    data-vv-name="description" required></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select v-bind:items="getAllCompanies" v-model="profile.company_code" label="Company code" item-value="company_code" :error-messages="errors.collect('company code')"
                    v-validate="'required'" data-vv-name="company code" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select v-bind:items="types" v-model="profile.type" label="Document type" item-value="type" :error-messages="errors.collect('document_type')"
                    v-validate="'required'" data-vv-name="document_type" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.type }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.type }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="onFormProfileSubmit" dark color="accent" :loading="getLoading" :disable="getLoading">update
          </v-btn>
          <v-btn to="/limit">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <v-card>
        <v-card-title>
          <span class="title">Approval limits</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="toggleDialogForm(null)">new limit</v-btn>
          </v-card-title>
          <v-data-table 
            hide-actions
            :loading="getLoading" 
            v-bind:headers="headers" 
            v-bind:items="limits" 
            v-model="selected"
            item-key="id" 
            class="elevation-0 pb-5">
            <template slot="headerCell" slot-scope="props">
              <span>
                {{ props.header.text }}
              </span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <v-btn flat icon @click="toggleDialogForm(props.item.id)" color="accent lighten-1" slot="activator">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Change</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn flat icon @click="toggleDialog(props.item.id)" color="error lighten-1" slot="activator">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </td>
              <td class="text-xs-right">
                {{ props.item.total_value_from | currency}}
              </td>
              <td class="text-xs-right">
                {{ props.item.total_value_to === 0 ? 'Unlimited' : $options.filters.currency(props.item.total_value_to)}}
              </td>
              
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-limit',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      selectedId: '',
      profile: {},
      limits: [],
      selected: [],
      types: [
        {
          type: 'PR',
          description: 'Purchase requisition'
        },
        {
          type: 'PO',
          description: 'Purchase order'
        }
      ],
      activeLimit: {
        approval_profile_id: '',
        total_value_from: 0,
        total_value_to: 0,
        is_unlimited: '0'
      },
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Min. limit',
          align: 'right',
          value: 'total_value_from'
        },
        {
          text: 'Max. limit',
          align: 'right',
          value: 'total_value_to'
        }
      ],
      dialog: false,
      dialogForm: false,
      dialogTitle: '',
      isUnlimited: '',
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  computed: {
    ...mapGetters([
      'getActiveApprovalProfile',
      'getLoading',
      'getApprovalLimits',
      'getAllCompanies',
      'getResponse',
      'getNextMinLimit'
    ])
  },
  watch: {
    getApprovalLimits: function () {
      this.limits = this.getApprovalLimits.slice()
    }
  },
  methods: {
    ...mapActions([
      'setActiveApprovalProfile',
      'fetchAllCompanies',
      'fetchApprovalLimits',
      'fetchActiveApprovalProfile',
      'deleteApprovalLimit',
      'addApprovalLimit',
      'changeApprovalLimit',
      'changeApprovalProfile'
    ]),

    toggleDialog: function (id) {
      this.selectedId = id
      this.dialog = true
    },

    toggleDialogForm: function (id) {
      if (id) {
        this.dialogTitle = 'Change'
        this.selectedId = id
        let temp = this.limits.find(limit => limit.id === id)
        this.activeLimit.approval_profile_id = temp.approval_profile_id
        this.activeLimit.total_value_from = temp.total_value_from
        this.activeLimit.total_value_to = temp.total_value_to
        this.activeLimit.is_unlimited = temp.total_value_to === 0 ? '1' : '0'
      } else {
        this.dialogTitle = 'New'
        this.activeLimit.approval_profile_id = this.id
        this.activeLimit.total_value_from = this.getNextMinLimit
        this.activeLimit.total_value_to = 0
        this.activeLimit.is_unlimited = '0'
      }
      this.dialogForm = true
    },

    onFormProfileSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changeApprovalProfile(this.profile).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    newLimit: function () {
      this.addApprovalLimit(this.activeLimit).then(() => {
        this.dialogForm = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Added successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    changeLimit: function () {
      let payload = {
        selectedId: this.selectedId,
        limit: this.activeLimit
      }
      this.changeApprovalLimit(payload).then(() => {
        this.dialogForm = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Changed successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    dialogFormSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dialogTitle === 'Change') {
            this.changeLimit()
          } else {
            this.newLimit()
          }
        }
      })
    },

    deleteLimitById: function () {
      let payload = {
        approval_limit_id: this.selectedId,
        approval_profile_id: this.id
      }
      this.deleteApprovalLimit(payload).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    }
  },
  mounted: function () {
    if (this.getAllCompanies.length === 0) {
      this.fetchAllCompanies()
    }

    this.fetchActiveApprovalProfile(this.id)
      .then(() => {
        this.profile = Object.assign({}, this.getActiveApprovalProfile)
        this.limits = this.getApprovalLimits.slice()
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/approval-limit/ChangeLimit.vue